import React, { Component } from "react";
import { Alert, Button, Row, Col } from "reactstrap";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { VerificarDocumentoIntegranteStore } from "../../../containers/personaReferencia/verificarDocumentoIntegrante/VerificarDocumentoIntegrante.store";
import { VerificarDocumentoIntegranteDispatcher } from "../../../containers/personaReferencia/verificarDocumentoIntegrante/VerificarDocumentoIntegrante.dispatcher";
import constants from "../../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const URL_BASE = `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/`;

interface Props
  extends VerificarDocumentoIntegranteStore,
    VerificarDocumentoIntegranteDispatcher {
  idMembresiaSocioPersona: number;
  onSuccess: () => void;
  onClose: () => void;
}

interface State {}

export default class VerificarDocumentoIntegranteComponent extends Component<
  Props,
  State
> {
  state = {};

  async componentDidMount() {
    const preview = await this.props.getIdentificacionIntegranteExtranjero(
      this.props.idMembresiaSocioPersona
    );

    if (!preview.fulfilled) {
      errorNotification(preview.gettingIdentificacionIntegranteExtranjeroError);
    }
  }

  componentWillUnmount() {
    this.props.clearPersonaReferencia();
  }

  handleConfirm = async () => {
    const {
      idMembresiaSocioPersona,
      postVerificarDocumentoIntegrante
    } = this.props;
    const preview = await postVerificarDocumentoIntegrante(
      idMembresiaSocioPersona
    );

    if (
      preview.fulfilled &&
      preview.verificacionDocumentoIntegrante.resolucion
    ) {
      successNotification("Documento del integrante verificado exitosamente");
    } else if (preview.fulfilled) {
      errorNotification("El documento es inválido, revise el resultado");
    } else {
      errorNotification(
        preview.postingVerificarDocumentoIntegranteError ||
          "Error al verificar documento del integrante"
      );
    }
  };

  render() {
    const {
      postingVerificarDocumentoIntegrante: verificando,
      verificacionDocumentoIntegrante: resultado,
      gettingIdentificacionIntegranteExtranjero: buscandoArchivo,
      identificacionIntegranteExtranjero: archivo
    } = this.props;

    const loading = verificando || buscandoArchivo;
    const razonamientoArchivo =
      !!archivo && !!archivo.verificacionExtranjero
        ? archivo.verificacionExtranjero.razonamiento
        : "";
    const extranjeroVerificado = !resultado
      ? archivo && archivo.extranjeroVerificado
      : resultado.resolucion;
    const razonamiento = !resultado
      ? razonamientoArchivo
      : resultado.razonamiento;

    return (
      <div style={{ marginRight: "15px" }}>
        <Row>
          {/* Columna izquierda: Información y acciones */}
          <Col md={4}>
            <div style={{ maxHeight: "600px", overflowY: "auto" }}>
              {/* Información del análisis */}
              {!!verificando && (
                <div className="text-center p-5">
                  <FontAwesomeIcon icon={faSpinner} pulse size="3x" />
                  <p className="mt-3">Expere un momento...</p>
                </div>
              )}

              {!loading && archivo && (
                <Alert color={extranjeroVerificado ? "success" : "danger"}>
                  <p className="mb-0 mt-2 font-bold">
                    {extranjeroVerificado
                      ? "La identificación ya se aprobó"
                      : "La identificación no ha sido verificada"}
                  </p>
                  <p className="mb-0 mt-2">
                    {!!razonamiento && "Resultado: "}
                    {razonamiento ||
                      "Aún no se ha analizado el documento, intente por favor"}
                  </p>
                </Alert>
              )}

              {!loading && resultado && (
                <div>
                  <h6 className="mb-3">Resumen de la Verificación</h6>

                  <table className="table table-sm table-bordered">
                    <tbody>
                      <tr>
                        <th style={{ fontSize: "0.85rem" }}>
                          Verificación exitosa:
                        </th>
                        <td>
                          {resultado.resolucion ? (
                            <span className="badge badge-success">Sí</span>
                          ) : (
                            <span className="badge badge-danger">No</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th style={{ fontSize: "0.85rem" }}>
                          Los nombres coinciden:
                        </th>
                        <td>
                          {resultado.nombreCoincide ? (
                            <span className="badge badge-success">Sí</span>
                          ) : (
                            <span className="badge badge-danger">No</span>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th style={{ fontSize: "0.85rem" }}>
                          La fecha de nac. coincide:
                        </th>
                        <td>
                          {resultado.fechaNacimientoCoincide ? (
                            <span className="badge badge-success">Sí</span>
                          ) : (
                            <span className="badge badge-danger">No</span>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {!loading && !!archivo && !extranjeroVerificado && (
                <>
                  <hr />
                  <p className="mt-3 mb-4">
                    Confirme el análisis del documento
                  </p>

                  <div className="text-right">
                    <Button
                      color="secondary"
                      onClick={this.props.onClose}
                      size="sm"
                    >
                      Cancelar
                    </Button>
                    <Button
                      style={{ marginLeft: "15px" }}
                      className="primaryButton"
                      onClick={this.handleConfirm}
                      size="sm"
                    >
                      {verificando ? "Verificando..." : "Verificar"}
                    </Button>
                  </div>
                </>
              )}

              {!loading && !archivo && (
                <>
                  <p className="mt-3 mb-4">
                    Antes de realizar esta acción, debe cargar la identificación
                  </p>

                  <div className="text-right">
                    <Button
                      color="secondary"
                      onClick={this.props.onClose}
                      size="sm"
                    >
                      Cerrar
                    </Button>
                  </div>
                </>
              )}

              {!loading && !!extranjeroVerificado && (
                <>
                  <hr />
                  <div className="text-right">
                    <Button
                      color="secondary"
                      onClick={this.props.onSuccess}
                      size="sm"
                    >
                      Finalizar
                    </Button>
                  </div>
                </>
              )}
            </div>
          </Col>

          {/* Columna derecha: Visor del documento */}
          <Col
            md={8}
            style={
              archivo && archivo.storage
                ? { background: "#444", color: "#fff" }
                : { background: "#444", color: "#ddd" }
            }
          >
            {!!buscandoArchivo && (
              <div className="text-center p-5">
                <FontAwesomeIcon icon={faSpinner} pulse size="3x" />
                <p className="mt-3">Cargando documento...</p>
              </div>
            )}
            {!(!!archivo && !!archivo.storage) && !loading && (
              <h5 style={{ textAlign: "center", marginTop: "15px" }}>
                No ha cargado la identificación del cliente
              </h5>
            )}
            {!!archivo && !!archivo.storage && (
              <div style={{ margin: "0 -15px" }}>
                <iframe
                  src={`${URL_BASE}${archivo.storage}`}
                  style={{
                    width: "100%",
                    height: "600px",
                    border: "1px solid #444"
                  }}
                  title="Documento de Identificación"
                />
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
